"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7815],{

/***/ 57815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ article_default; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(15072);
// EXTERNAL MODULE: ./src/utils/datalayer/send-datalayer.js
var send_datalayer = __webpack_require__(34892);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
;// CONCATENATED MODULE: ./src/components/widgets/widget-bylines.js



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0px 0 16px;\n  filter: ",
        ";\n  .title-byline {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #7e7e7e;\n    font-size: 20px;\n    margin: 0 10px 0px 0;\n  }\n  .flex-end {\n    display: flex;\n    justify-content: end;\n  }\n  p.by-line {\n    cursor: pointer;\n    color: #373636;\n    background: #c8c8c8;\n    padding: 3px 10px;\n    margin-right: 10px;\n    border-radius: 0 10px;\n    :hover {\n      background: #d2def2;\n    }\n  }\n  a.by-line {\n    cursor: pointer;\n    color: #373636;\n    background: #c8c8c8;\n    padding: 3px 10px;\n    margin-left: 10px;\n    border-radius: 0 10px;\n    :hover {\n      background: #d2def2;\n    }\n  }\n  @media (max-width: 767px) {\n    display: block;\n    flex-wrap: wrap;\n    .by-line {\n      margin-bottom: 5px;\n      text-align: end;\n      width: fit-content;\n    }\n  }\n  @media (max-width: 767px) {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 16px 0 10px;\n    p.by-line,\n    a.by-line {\n      margin: 0 5px;\n    }\n    .title-byline {\n      margin: 0 5px 0 0;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var WidgetBylines = function(param) {
    var eventDataLayer = param.eventDataLayer, article = param.article;
    var ref, ref1;
    var bylines = ((ref = article === null || article === void 0 ? void 0 : article.bylineList) !== null && ref !== void 0 ? ref : []).map(function(item) {
        return String((ref1 = item === null || item === void 0 ? void 0 : item.p_name) !== null && ref1 !== void 0 ? ref1 : "").trim();
    }).filter(function(name) {
        return name !== "";
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetWrapper, {
            gray: constants/* SHOW_COMMEMORATE */.WT === "true",
            id: "byline-wrapper",
            children: bylines.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "title-byline",
                        children: " By "
                    }),
                    bylines.map(function(name, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex-end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "/bylines/".concat(encodeURIComponent(name)),
                                "aria-label": "ดูบทความของ ".concat(name),
                                onClick: function() {
                                    return (0,send_datalayer/* sendDataLayerGlobal */.dE)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, eventDataLayer), {
                                        section: "นามปากกา:".concat(name)
                                    }));
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "by-line",
                                    children: name
                                })
                            })
                        }, index);
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "title-byline",
                        children: " By "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-end",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "/bylines/กรุงเทพธุรกิจ",
                            onClick: function() {
                                return (0,send_datalayer/* sendDataLayerGlobal */.dE)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, eventDataLayer), {
                                    section: "นามปากกา:กรุงเทพธุรกิจ"
                                }));
                            },
                            "aria-label": "ดูบทความของ กรุงเทพธุรกิจ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "by-line",
                                children: "กรุงเทพธุรกิจ"
                            })
                        })
                    })
                ]
            })
        })
    });
};
var WidgetWrapper = styled_components_browser_esm["default"].div(_templateObject(), function(props) {
    return props.gray ? "grayscale(0.7)" : "none";
});
/* harmony default export */ var widget_bylines = (WidgetBylines);

// EXTERNAL MODULE: ./src/utils/ads/dynamic-ads.js
var dynamic_ads = __webpack_require__(84920);
// EXTERNAL MODULE: ./src/utils/helper.js
var helper = __webpack_require__(39334);
;// CONCATENATED MODULE: ./src/utils/contents/get-affiliate.js



var getAffiliate = function(_position, _data) {
    if ((0,helper/* arrayEmpty */.c_)(_data) || !_data) return null;
    var item = _data.filter(function(_item) {
        return (_item === null || _item === void 0 ? void 0 : _item.position) === _position;
    })[0];
    return item && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "content-detail text-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: item === null || item === void 0 ? void 0 : item.link,
            title: item === null || item === void 0 ? void 0 : item.title,
            target: "_blank",
            rel: "noopener noreferrer nofollow",
            children: (item === null || item === void 0 ? void 0 : item.image) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "".concat(constants/* APP_IMG */.T).concat(item === null || item === void 0 ? void 0 : item.image),
                alt: (item === null || item === void 0 ? void 0 : item.title) || "affaliate-".concat(_position)
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "btn-affaliate my-3",
                style: {
                    background: "".concat(item === null || item === void 0 ? void 0 : item.bgColor),
                    color: "".concat(item === null || item === void 0 ? void 0 : item.textColor)
                },
                children: item === null || item === void 0 ? void 0 : item.title
            })
        })
    });
};

// EXTERNAL MODULE: ./src/utils/contents/get-image.js
var get_image = __webpack_require__(14433);
// EXTERNAL MODULE: ./src/utils/devices.js
var devices = __webpack_require__(97348);
;// CONCATENATED MODULE: ./src/2.0/articles/article-default.js

function article_default_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* COMMEMORATE: หยดเฉพาะ media ใน card-feature เพราะใส่ filter ที่ .card-feature ตรงๆ ไม่ได้\n     (ข้างในมี widget แปลภาษา/แชร์ ที่เป็น position: fixed บนมือถือ) */\n  ",
        "\n  @media (max-width: 768px) {\n    .container {\n      padding-right: 0px;\n      padding-left: 0px;\n    }\n  }\n  @media (max-width: 690px) {\n    .mobile-only {\n      display: block;\n      max-width: 90vw !important;\n    }\n    .desktop-only {\n      display: none;\n    }\n  }\n  @media (min-width: 691px) {\n    .mobile-only {\n      display: none;\n    }\n    .desktop-only {\n      display: block;\n    }\n  }\n  .hight-widget-meta-content {\n    min-height: 40px;\n    @media (min-width: 691px) {\n      min-height: 60px;\n    }\n  }\n  .hight-widget-meta-content-mb {\n    min-height: 60px;\n  }\n  .article-wrapper {\n    display: grid;\n    grid-template-columns: 750px 1fr;\n    grid-gap: 20px;\n    .block-1 {\n      background: linear-gradient(0deg, rgba(255, 255, 255, 1) 70%, rgba(255, 255, 255, 0) 100%);\n      padding: 20px 16px;\n\n      .article-title {\n        display: flex;\n        justify-content: flex-start;\n        align-items: center;\n        margin: 10px 0;\n        font-size: 48px;\n        font-family: 'DBHelvethaicaXBd', sans-serif !important;\n        line-height: 1.15;\n        font-weight: 500;\n        color: var(--primary-gray);\n        -webkit-line-clamp: initial;\n        @media (min-width: 767px) {\n          min-height: 100px;\n        }\n        @media (max-width: 767px) {\n          font-size: 32px;\n          justify-content: center;\n          min-height: 100px;\n        }\n      }\n    }\n    .mt-3 {\n      margin-top: 1.5rem;\n    }\n    .byline {\n      color: #a3a3a3;\n      font-size: 20px;\n      margin: 10px 0;\n      @media (max-width: 767px) {\n        text-align: center;\n      }\n    }\n    .card-feature {\n      max-width: 100%;\n      overflow-x: visible;\n      overflow-y: visible;\n    }\n    .card-feature .resolution-image {\n      display: block;\n      width: 100%;\n      max-width: 100%;\n    }\n    .card-feature .resolution-image img {\n      display: block;\n      width: 100% !important;\n      max-width: 100% !important;\n      height: auto !important;\n    }\n    .card-feature .embed-responsive {\n      max-width: 100%;\n    }\n    .card-feature iframe {\n      display: block;\n      width: 100% !important;\n      max-width: 100%;\n    }\n    .block-2 {\n      padding-top: 30px;\n      .widget-heading {\n        .heading {\n          font-weight: 400;\n          color: var(--primary-gray);\n          background-color: var(--background-color);\n        }\n      }\n      ul.block-list {\n        margin-top: 20px;\n        list-style-type: none;\n        padding: 0;\n        li {\n          margin-bottom: 20px;\n          .card-h-thumb,\n          .card-h-thumb img {\n            border-radius: 8px;\n          }\n          .card-h-content-title {\n            font-size: 18pt;\n            line-height: 1.15;\n            font-weight: 400;\n            color: var(--primary-gray);\n          }\n        }\n      }\n    }\n\n    @media (max-width: 768px) {\n      grid-template-columns: 1fr;\n      .block-1 {\n        /* padding: 10px; */\n        overflow-x: hidden;\n        width: 100%;\n      }\n    }\n  }\n  .content-blurb {\n    background-color: var(--blockquote-color);\n    border: 1px solid var(--border-blue);\n    box-shadow: 0 0 5px 0 var(--border-blue);\n    border-radius: 5px;\n    font-family: 'Sarabun', sans-serif;\n    font-size: 20px;\n    line-height: 1.55;\n    font-weight: 600;\n    padding: 20px;\n    margin: 30px 0;\n    color: var(--secondary-blue);\n    blockquote {\n      margin: 0;\n    }\n  }\n\n  /* ใน styled-component ของ ArticleDefault */\n\n  @media (max-width: 768px) {\n    .ads-inarticle-1,\n    .ads-inarticle-2,\n    .ads-inarticle-3 {\n      margin-left: -22px;\n      margin-right: -22px;\n      width: 100vw;\n      max-width: 100vw;\n      overflow: hidden;\n      background: rgb(245, 245, 245);\n    }\n  }\n\n  .content-detail {\n    font-weight: 300;\n    margin-bottom: 15px;\n    line-height: 1.85;\n    word-break: break-word;\n    color: var(--text-color);\n    // & > ul {\n    //   margin-top: 15px;\n    // }\n    p {\n      margin: 14px 0px;\n    }\n    h2 {\n      position: relative;\n      display: block;\n      margin: auto;\n      font-size: 20pt;\n      font-weight: 500;\n      color: var(--secondary-blue);\n      /* padding: 15px 0; */\n      line-height: 1.35;\n      margin-left: 15px;\n      @media (max-width: 475px) {\n        padding-left: 5px;\n      }\n    }\n    h2::before {\n      content: '';\n      display: block;\n      width: 8px;\n      height: 8px;\n      background-color: var(--secondary-blue);\n      border-radius: 50%;\n      position: absolute;\n      top: 19px;\n      left: -20px;\n      transform: translateY(-50%);\n\n      @media (max-width: 768px) {\n        left: -17px;\n      }\n      @media (max-width: 690px) {\n        left: -15px;\n      }\n      @media (max-width: 475px) {\n        left: -10px;\n      }\n    }\n    p,\n    strong,\n    span,\n    em,\n    a,\n    h1,\n    h3,\n    h4,\n    h5,\n    ul,\n    li {\n      /* color: var(--text-color); */\n      font-size: 18px !important;\n      font-family: 'Sarabun', sans-serif !important;\n    }\n\n    li {\n      max-width: 800px;\n      @media (max-width: 475px) {\n        max-width: 300px;\n      }\n    }\n\n    strong {\n      font-weight: 700;\n    }\n\n    img {\n      width: 100% !important;\n      max-width: 700px !important;\n      height: auto !important;\n    }\n\n    blockquote > p,\n    blockquote > span,\n    blockquote > strong,\n    blockquote > ul {\n      background: aliceblue;\n      color: #4242b3 !important;\n      padding: 30px;\n      margin: 10px;\n      border-left: 5px solid #479be4;\n      font-style: italic;\n      font-weight: 400;\n      @media (max-width: 768px) {\n        padding: 15px 20px;\n      }\n    }\n\n    blockquote > p span,\n    blockquote > p strong {\n      color: #4242b3 !important;\n      font-size: 20px !important;\n    }\n\n    blockquote > ul {\n      padding-left: 40px;\n\n      @media (max-width: 768px) {\n        padding-left: 40px;\n      }\n    }\n\n    p {\n      span {\n        img {\n          width: 100%; //important\n          margin: 15px auto;\n          display: block;\n          max-width: 100% !important;\n\n          @media (max-width: 767px) {\n            width: 100% !important;\n            height: auto !important;\n          }\n        }\n      }\n    }\n\n    p {\n      img {\n        display: block;\n        height: auto !important;\n        width: auto !important;\n        margin: 10px auto !important;\n        max-width: 100% !important;\n        max-height: 600px !important;\n      }\n    }\n\n    p > picture > img {\n      display: block;\n      height: auto !important;\n      width: auto !important;\n      margin: 10px auto !important;\n      max-width: 100% !important;\n      max-height: 600px !important;\n    }\n\n    a {\n      color: #2980b9 !important;\n      span {\n        color: #2980b9 !important;\n      }\n      &:hover {\n        color: #185985 !important;\n        span {\n          color: #185985 !important;\n        }\n      }\n    }\n\n    iframe {\n      display: block !important;\n      position: relative !important;\n      margin: 15px auto !important;\n      width: 100% !important;\n      height: 100% !important;\n      min-height: 315px !important;\n      max-width: 560px !important;\n      max-height: 315px;\n      // max-width: 100% !important;\n\n      @media (max-width: 540px) {\n        min-height: 200px !important;\n      }\n    }\n\n    picture {\n      span {\n        position: relative;\n        background-color: $main-color;\n        border-radius: 0px 0px 10px 10px;\n        color: #fff;\n        display: block;\n        width: 100%;\n        padding: 5px 10px;\n        padding-right: 25px !important;\n        font-size: 14px;\n        margin: -10px auto 15px 0px;\n        line-height: 1.6;\n      }\n    }\n\n    .image-caption {\n      font-weight: 400;\n      font-size: 13px !important;\n      font-style: italic;\n      letter-spacing: 0px;\n    }\n\n    // iframe dailymotion start\n    div[style='position:relative;padding-bottom:56.25%;height:0;overflow:hidden;'] > iframe {\n      display: block;\n      position: relative !important;\n      margin: 20px auto !important;\n      max-width: 100% !important;\n      height: 420px;\n      @media (max-width: 767px) {\n        height: 210px !important;\n      }\n    }\n    div[style='position:relative;padding-bottom:56.25%;height:0;overflow:hidden;'] {\n      height: 420px !important;\n      margin: 20px auto;\n      @media (max-width: 767px) {\n        height: 210px !important;\n      }\n    }\n    // iframe dailymotion end\n  }\n  .related-news-desktop {\n    width: 420px;\n    margin: auto;\n    min-height: unset;\n    max-width: 100%;\n    @media (max-width: 767px) {\n      width: unset;\n    }\n    // @media (max-width: 767px) {\n    //   margin: -40px auto -10px auto;\n    // }\n  }\n"
    ]);
    article_default_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






// import StickyBox from 'react-sticky-box';
// import Carousels from 'src/components/carousels';


// import DynamicAds, { KEY_ADS_POSITION } from 'src/utils/ads/dynamic-ads';






// import WidgetBreadcrumb from 'src/2.0/widgets/widget-breadcrumb';
var StickyBox = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1033), __webpack_require__.e(2836)]).then(__webpack_require__.bind(__webpack_require__, 42836));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(42836)
            ];
        }
    },
    ssr: true
});
var Carousels = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1033), __webpack_require__.e(6066), __webpack_require__.e(951)]).then(__webpack_require__.bind(__webpack_require__, 20951));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(20951)
            ];
        }
    },
    ssr: false
});
var DynamicAds = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 84920));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84920)
            ];
        }
    },
    ssr: true
});
var CardH = dynamic_default()(__webpack_require__.e(/* import() */ 9789).then(__webpack_require__.bind(__webpack_require__, 9789)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9789)
            ];
        }
    },
    ssr: true
});
var AdsNative = dynamic_default()(__webpack_require__.e(/* import() */ 4152).then(__webpack_require__.bind(__webpack_require__, 94152)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94152)
            ];
        }
    },
    ssr: false
});
var WidgetBreadcrumb = dynamic_default()(__webpack_require__.e(/* import() */ 6552).then(__webpack_require__.bind(__webpack_require__, 36552)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(36552)
            ];
        }
    },
    ssr: true
});
var WidgetHeading = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(2777), __webpack_require__.e(2657)]).then(__webpack_require__.bind(__webpack_require__, 2657)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2657)
            ];
        }
    },
    ssr: false
});
var WidgetKeypoint = dynamic_default()(__webpack_require__.e(/* import() */ 221).then(__webpack_require__.bind(__webpack_require__, 20221)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(20221)
            ];
        }
    },
    ssr: true
});
var WidgetMetaContent = dynamic_default()(__webpack_require__.e(/* import() */ 8511).then(__webpack_require__.bind(__webpack_require__, 98511)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(98511)
            ];
        }
    },
    ssr: false
});
var WidgetTags = dynamic_default()(__webpack_require__.e(/* import() */ 6758).then(__webpack_require__.bind(__webpack_require__, 66758)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(66758)
            ];
        }
    },
    ssr: true
});
var WidgetByline = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7925), __webpack_require__.e(52)]).then(__webpack_require__.bind(__webpack_require__, 60052));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60052)
            ];
        }
    }
});
var ArticleDefault = function(param) {
    var translated = param.translated, isKeyPoint = param.isKeyPoint, article = param.article, ads = param.ads, dataAffiliate = param.dataAffiliate, lastNews = param.lastNews, dataAdsNative = param.dataAdsNative, related = param.related;
    var generateAdConfig = function generateAdConfig(position, dataArray) {
        // หาตำแหน่งข้อมูลที่ match กับ position
        var foundItem = dataArray === null || dataArray === void 0 ? void 0 : dataArray.find(function(item) {
            return (item === null || item === void 0 ? void 0 : item.position) === position;
        });
        // ถ้าเจอ item ใช้ otherScript แทน body ไม่งั้นใช้ defaultBody
        var bodyContent = (foundItem === null || foundItem === void 0 ? void 0 : foundItem.otherScript) || "";
        return bodyContent;
    };
    var ref;
    var router = (0,next_router.useRouter)();
    var responsive = (0,devices/* default */.Z)();
    var isMobile = (0,devices/* default */.Z)().isMobile;
    var isMb = (0,react_responsive.useMediaQuery)({
        query: "(max-width: 768px)"
    });
    // console.log('native-below-article-mobile :', generateAdConfig('native-below-article-mobile', ads), !isMobile, dataAdsNative);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "article-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "block-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetBreadcrumb, {
                                article: article
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hight-widget-meta-content desktop-only",
                                style: {
                                    filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : ""
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetMetaContent, {
                                    article: article
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                className: "article-title",
                                style: {
                                    filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : ""
                                },
                                children: [
                                    " ",
                                    article.title,
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "desktop-only",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(widget_bylines, {
                                    eventDataLayer: {
                                        type: send_datalayer/* DATALAYER_TYPE.TRACK_POSITION */.$7.TRACK_POSITION,
                                        router: router === null || router === void 0 ? void 0 : router.pathname,
                                        section: "Byline",
                                        position: "ใต้:รูปหลัก"
                                    },
                                    article: article
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "card-feature",
                                children: [
                                    (0,get_image/* getFeatureImage */.k)(article, false, true),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mobile-only",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(widget_bylines, {
                                            eventDataLayer: {
                                                type: send_datalayer/* DATALAYER_TYPE.TRACK_POSITION */.$7.TRACK_POSITION,
                                                router: router === null || router === void 0 ? void 0 : router.pathname,
                                                section: "Byline",
                                                position: "ใต้:รูปหลัก"
                                            },
                                            article: article
                                        })
                                    }),
                                    translated,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "hight-widget-meta-content-mb mobile-only",
                                        style: {
                                            filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : ""
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetMetaContent, {
                                            article: article,
                                            showByline: false
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                id: "content",
                                className: "content-wrapper",
                                children: [
                                    isEmpty_default()(article.key_point) && (article === null || article === void 0 ? void 0 : article.blurb) !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "content-blurb",
                                        style: {
                                            filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : ""
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", {
                                            dangerouslySetInnerHTML: {
                                                __html: article === null || article === void 0 ? void 0 : article.blurb
                                            }
                                        })
                                    }),
                                    !isEmpty_default()(article.key_point) && /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetKeypoint, {
                                        isKeyPoint: isKeyPoint,
                                        article: article,
                                        style: {
                                            filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : ""
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        id: "paragraph",
                                        children: [
                                            (article === null || article === void 0 ? void 0 : article.content_I) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    (article === null || article === void 0 ? void 0 : article.is_creden) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        id: "paragraph-1",
                                                        "data-news-content": "company",
                                                        style: {
                                                            filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : ""
                                                        },
                                                        className: "content-detail",
                                                        dangerouslySetInnerHTML: {
                                                            __html: article === null || article === void 0 ? void 0 : article.content_I
                                                        }
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        id: "paragraph-1",
                                                        className: "content-detail",
                                                        style: {
                                                            filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : ""
                                                        },
                                                        dangerouslySetInnerHTML: {
                                                            __html: article === null || article === void 0 ? void 0 : article.content_I
                                                        }
                                                    }),
                                                    (article === null || article === void 0 ? void 0 : article.is_show_ads) && getAffiliate(1, dataAffiliate),
                                                    (article === null || article === void 0 ? void 0 : article.is_show_ads) && !isEmpty_default()(ads) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicAds, {
                                                        position: dynamic_ads.KEY_ADS_POSITION.INARTICLE_1,
                                                        data: ads
                                                    })
                                                ]
                                            }),
                                            (article === null || article === void 0 ? void 0 : article.content_II) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    (article === null || article === void 0 ? void 0 : article.is_creden) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        id: "paragraph-2",
                                                        "data-news-content": "company",
                                                        className: "content-detail",
                                                        style: {
                                                            filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : ""
                                                        },
                                                        dangerouslySetInnerHTML: {
                                                            __html: article === null || article === void 0 ? void 0 : article.content_II
                                                        }
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        id: "paragraph-2",
                                                        className: "content-detail",
                                                        style: {
                                                            filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : ""
                                                        },
                                                        dangerouslySetInnerHTML: {
                                                            __html: article === null || article === void 0 ? void 0 : article.content_II
                                                        }
                                                    }),
                                                    (article === null || article === void 0 ? void 0 : article.is_show_ads) && getAffiliate(2, dataAffiliate),
                                                    (article === null || article === void 0 ? void 0 : article.is_show_ads) && !isEmpty_default()(ads) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicAds, {
                                                        position: dynamic_ads.KEY_ADS_POSITION.INARTICLE_2,
                                                        data: ads
                                                    })
                                                ]
                                            }),
                                            !generateAdConfig("native-in-article-related", ads) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: !isEmpty_default()(related) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "widget-content related-news-desktop",
                                                    style: {
                                                        filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : ""
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "widget-content-title",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "related-news fw-500",
                                                                children: "เนื้อหาที่เกี่ยวข้อง"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "block-content",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                className: "block-list",
                                                                children: related.slice(0, 3).map(function(item, index) {
                                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardH, {
                                                                            data: item,
                                                                            large: false,
                                                                            external: false,
                                                                            loading: "lazy",
                                                                            //! DATALAYER
                                                                            eventDataLayer: {
                                                                                type: send_datalayer/* DATALAYER_TYPE.TRACK_POSITION */.$7.TRACK_POSITION,
                                                                                router: router === null || router === void 0 ? void 0 : router.pathname,
                                                                                section: "เนื้อหาที่เกี่ยวข้อง",
                                                                                position: "ใต้:paragraph-2",
                                                                                data: {
                                                                                    block: "1",
                                                                                    title: item === null || item === void 0 ? void 0 : item.title,
                                                                                    heading: "เนื้อหาที่เกี่ยวข้อง",
                                                                                    index: index + 1
                                                                                }
                                                                            }
                                                                        })
                                                                    }, index);
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: (article === null || article === void 0 ? void 0 : article.is_show_ads) && !isEmpty_default()(ads) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: generateAdConfig("native-in-article-related", ads)
                                                    }
                                                })
                                            }),
                                            (article === null || article === void 0 ? void 0 : article.content_III) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    (article === null || article === void 0 ? void 0 : article.is_show_ads) && !isEmpty_default()(ads) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicAds, {
                                                        position: dynamic_ads.KEY_ADS_POSITION.INARTICLE_3,
                                                        data: ads
                                                    }),
                                                    (article === null || article === void 0 ? void 0 : article.is_creden) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        id: "paragraph-3",
                                                        "data-news-content": "company",
                                                        className: "content-detail",
                                                        style: {
                                                            filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : ""
                                                        },
                                                        dangerouslySetInnerHTML: {
                                                            __html: article === null || article === void 0 ? void 0 : article.content_III
                                                        }
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        id: "paragraph-3",
                                                        className: "content-detail",
                                                        style: {
                                                            filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : ""
                                                        },
                                                        dangerouslySetInnerHTML: {
                                                            __html: article === null || article === void 0 ? void 0 : article.content_III
                                                        }
                                                    }),
                                                    (article === null || article === void 0 ? void 0 : article.is_show_ads) && getAffiliate(3, dataAffiliate)
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetByline, {
                                data: article === null || article === void 0 ? void 0 : article.bylineList
                            }),
                            (article === null || article === void 0 ? void 0 : (ref = article.tags) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetTags, {
                                id: "read-complete",
                                tags: article === null || article === void 0 ? void 0 : article.tags
                            }),
                            (article === null || article === void 0 ? void 0 : article.is_show_ads) && !isEmpty_default()(ads) && generateAdConfig("native-below-article-mobile", ads) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "inarticle-3 mt-3 mobile-only",
                                style: {
                                    filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : ""
                                },
                                children: (article === null || article === void 0 ? void 0 : article.is_show_ads) && !isEmpty_default()(ads) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: generateAdConfig("native-below-article-mobile", ads)
                                    }
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-3 mobile-only ",
                                style: {
                                    filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : ""
                                },
                                children: !(0,helper/* arrayEmpty */.c_)(lastNews) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousels, {
                                    showDots: true,
                                    autoPlay: false,
                                    responsiveShow: 1,
                                    children: !(0,helper/* arrayEmpty */.c_)(lastNews) && lastNews.map(function(item, index) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                            className: "card-carousel",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardH, {
                                                withTarget: true,
                                                external: false,
                                                data: item,
                                                path: item.link,
                                                loading: "lazy",
                                                eventDataLayer: {
                                                    type: send_datalayer/* DATALAYER_TYPE.TRACK_POSITION */.$7.TRACK_POSITION,
                                                    router: router === null || router === void 0 ? void 0 : router.pathname,
                                                    section: "Latest News",
                                                    position: "ใต้:แชร์ข่าว",
                                                    data: {
                                                        block: "1",
                                                        title: item === null || item === void 0 ? void 0 : item.title,
                                                        heading: "Latest News",
                                                        carousel: index + 1
                                                    }
                                                }
                                            })
                                        }, index);
                                    })
                                }) : null
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-3",
                                style: {
                                    filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : ""
                                },
                                children: (article === null || article === void 0 ? void 0 : article.is_show_ads) && !isEmpty_default()(ads) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: generateAdConfig("native-below-article", ads)
                                    }
                                })
                            }),
                            (article === null || article === void 0 ? void 0 : article.is_show_ads) && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdsNative, {
                                data: dataAdsNative,
                                isShowAds: article === null || article === void 0 ? void 0 : article.is_show_ads
                            }),
                            (article === null || article === void 0 ? void 0 : article.is_show_ads) && !isEmpty_default()(ads) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "postartice",
                                className: "ads-sticky-overflow",
                                style: {
                                    filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0)" : ""
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicAds, {
                                    position: dynamic_ads.KEY_ADS_POSITION.POSTARTICLE,
                                    data: ads
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "block-2",
                        children: !isMb && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StickyBox, {
                                offsetTop: 70,
                                offsetBottom: 70,
                                children: [
                                    (article === null || article === void 0 ? void 0 : article.is_show_ads) && !isEmpty_default()(ads) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicAds, {
                                        position: dynamic_ads.KEY_ADS_POSITION.STICKY_1,
                                        data: ads
                                    }),
                                    (article === null || article === void 0 ? void 0 : article.is_show_ads) && !isEmpty_default()(ads) && generateAdConfig("native-right-stream-desktop", ads) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : ""
                                        },
                                        dangerouslySetInnerHTML: {
                                            __html: generateAdConfig("native-right-stream-desktop", ads)
                                        }
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : ""
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetHeading, {
                                                heading: "Latest News"
                                            }),
                                            !Array.isArray(lastNews) && lastNews.length < 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "no-article",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: "--side",
                                                    src: "".concat(constants/* APP_IMG */.T, "/no-article.png"),
                                                    alt: "no-article",
                                                    width: "100%",
                                                    loading: "lazy"
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                className: "block-list",
                                                children: lastNews.slice(0, 4).map(function(item, index) {
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardH, {
                                                            data: item,
                                                            large: false,
                                                            showPublishDate: true,
                                                            loading: "lazy",
                                                            //! DATALAYER
                                                            eventDataLayer: {
                                                                type: send_datalayer/* DATALAYER_TYPE.TRACK_POSITION */.$7.TRACK_POSITION,
                                                                router: router === null || router === void 0 ? void 0 : router.pathname,
                                                                section: "Latest News",
                                                                position: "ใต้:โฆษณาตำแหน่ง Sticky Box",
                                                                data: {
                                                                    block: "2",
                                                                    title: item === null || item === void 0 ? void 0 : item.title,
                                                                    heading: "Latest News",
                                                                    index: index + 1
                                                                }
                                                            }
                                                        })
                                                    }, index);
                                                })
                                            })
                                        ]
                                    }),
                                    (article === null || article === void 0 ? void 0 : article.is_show_ads) && !isEmpty_default()(ads) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicAds, {
                                        position: dynamic_ads.KEY_ADS_POSITION.STICKY_2,
                                        data: ads
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var article_default = (ArticleDefault);
var SectionWrapper = styled_components_browser_esm["default"].div(article_default_templateObject(), constants/* SHOW_COMMEMORATE */.WT === "true" ? ".card-feature .resolution-image, .card-feature .embed-responsive,.card-feature .embed-dailymotion {  filter: grayscale(0.7); }" : "");


/***/ }),

/***/ 14433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ getFeatureImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_components_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84334);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15072);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(186);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  .embed-dailymotion {\n    width: 100%;\n    aspect-ratio: 16 / 9;\n    /* display: flex;\n    align-items: center;\n    justify-content: center; */\n    .dailymotion-player-root {\n      position: unset !important;\n    }\n    .resolution-video,\n    .resolution-dailymotion {\n      width: 100%;\n      height: 100%;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





// import styled from 'styled-components';
var getFeatureImage = function(_data) {
    var _showImg = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, _priority = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, _ignoreLazy = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    if (lodash__WEBPACK_IMPORTED_MODULE_2___default().isEmpty(_data)) return null;
    if (_showImg) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_image__WEBPACK_IMPORTED_MODULE_3__["default"], {
            image: _data === null || _data === void 0 ? void 0 : _data.image,
            title: _data === null || _data === void 0 ? void 0 : _data.title,
            ignoreLazy: _ignoreLazy,
            type: "FEATURE_IMAGE",
            width: 750,
            height: 422,
            loading: _priority ? "eager" : "lazy",
            fetchPriority: _priority ? "high" : "low"
        });
    }
    switch(_data === null || _data === void 0 ? void 0 : _data.type_video){
        case "0":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "embed-responsive embed-responsive-16by9",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("iframe", {
                    src: "".concat("".concat(src_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_IMG */ .T, "/").concat(_data === null || _data === void 0 ? void 0 : _data.video_src), "?autoplay=1")
                })
            });
        case "1":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EmbdedWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "embed-dailymotion",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        // className='embed-dailymotion'
                        dangerouslySetInnerHTML: {
                            __html: "\n              <script\n              defer\n              type='text/javascript'\n              src='".concat(src_constants__WEBPACK_IMPORTED_MODULE_4__/* .NEXT_DAILYMOTION_ID */ .pY, "'\n              data-video=").concat(_data === null || _data === void 0 ? void 0 : _data.video_src, "\n              ></script>")
                        }
                    })
                })
            });
        case "2":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "embed-responsive embed-responsive-16by9",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("iframe", {
                    src: "".concat(_data === null || _data === void 0 ? void 0 : _data.video_src, "?autoplay=1")
                })
            });
        default:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_image__WEBPACK_IMPORTED_MODULE_3__["default"], {
                className: "border-radius",
                image: _data === null || _data === void 0 ? void 0 : _data.image,
                title: _data === null || _data === void 0 ? void 0 : _data.title,
                ignoreLazy: _ignoreLazy,
                type: "FEATURE_IMAGE",
                class1: "br-8",
                width: 750,
                height: 422,
                loading: _priority ? "eager" : "lazy",
                fetchPriority: _priority ? "high" : "low"
            });
    }
};
// const EmbdedWrapper = styled.div`
//   position: absolute;
//   display: block;
//   width: 100%;
//   top: 0;
//   overflow: hidden;
//   .embed-dailymotion {
//     iframe {
//       width: 100%;
//       height: 480px;
//       @media (max-width: 500px) {
//         height: 220px;
//       }
//     }
//   }
// `;
var EmbdedWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div(_templateObject());


/***/ })

}]);